/* =====================================================================
   LP · Landing de producto (ALLMART) — interacciones
   - Animación de entrada al hacer scroll (respeta "reducir movimiento")
   - Tarjetas de paquete conectadas al selector de variantes de Horizon
   - Precio en vivo, barra fija de compra, sellos bajo el botón COD
   - Cuenta regresiva, carrusel con puntos, FAQ exclusivo, videos en vista
   ===================================================================== */
(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function onReady(fn) { if (doc.readyState !== 'loading') fn(); else doc.addEventListener('DOMContentLoaded', fn); }
  function cssEscape(v) { return window.CSS && CSS.escape ? CSS.escape(v) : String(v).replace(/"/g, '\\"'); }

  var cfg = {};
  try { cfg = JSON.parse(($('#lp-config') || {}).textContent || '{}'); } catch (e) { cfg = {}; }
  var variants = cfg.variants || [];

  var ICON_CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
  var ICON_ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';

  /* ---------- 1. Revelado al hacer scroll ---------- */
  function initReveal() {
    var items = $$('[data-lp-reveal]');
    $$('[data-lp-stagger]').forEach(function (group) {
      $$('[data-lp-reveal]', group).forEach(function (el, i) { el.style.setProperty('--i', i % 6); });
    });
    if (designMode || reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    root.classList.add('lp-js');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 2. Variantes: leer selección de Horizon y sincronizar la UI ---------- */
  function picker() { return $('.product-information variant-picker') || $('variant-picker'); }

  function selectedOptions() {
    var vp = picker();
    var out = {};
    if (!vp) return out;
    $$('fieldset input:checked', vp).forEach(function (inp) { out[inp.getAttribute('data-option-name')] = inp.value; });
    $$('select', vp).forEach(function (sel) {
      var m = /options\[(.+)\]/.exec(sel.name || '');
      if (m) out[m[1]] = sel.value;
    });
    return out;
  }

  function findVariant(sel) {
    var names = cfg.optionNames || [];
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var j = 0; j < names.length; j++) {
        if (sel[names[j]] !== undefined && v.options[j] !== sel[names[j]]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function currentVariant() {
    var byUrl = new URL(window.location.href).searchParams.get('variant');
    var sel = selectedOptions();
    var v = findVariant(sel);
    var info = packInfo();
    if (!v && info && sel[info.option] !== undefined) {
      // Combinación aún no válida (ej. traje + "Única"): usar la primera variante de ese paquete
      var partial = {}; partial[info.option] = sel[info.option];
      v = findVariant(partial);
    }
    if (!v && byUrl) v = variants.filter(function (x) { return String(x.id) === byUrl; })[0] || null;
    return v || variants[0] || null;
  }

  function setHidden(el, cls, hide) {
    if (!el) return;
    if (hide && !el.classList.contains(cls)) el.classList.add(cls);
    if (!hide && el.classList.contains(cls)) el.classList.remove(cls);
  }

  function packInfo() {
    var pack = $('[data-lp-pack]');
    if (!pack) return null;
    return {
      el: pack,
      option: pack.getAttribute('data-option'),
      sizeOption: pack.getAttribute('data-size-option'),
      single: (pack.getAttribute('data-single') || '').split('|').filter(Boolean)
    };
  }

  function syncUI() {
    var v = currentVariant();
    var info = packInfo();
    var vp = picker();

    // Precio del encabezado
    if (v) {
      $$('[data-lp-price-now]').forEach(function (el) { if (el.textContent !== v.price) el.textContent = v.price; });
      $$('[data-lp-price-was]').forEach(function (el) { el.textContent = v.compare || ''; el.hidden = !v.compare; });
      $$('[data-lp-price-off]').forEach(function (el) { el.textContent = v.off ? '-' + v.off + '%' : ''; el.hidden = !v.off; });
      var sp = $('.lp-sticky__price');
      if (sp && sp.textContent !== v.price) sp.textContent = v.price;
      var si = $('.lp-sticky__img');
      if (si && v.img && si.getAttribute('src') !== v.img) si.setAttribute('src', v.img);
      // La variante que leen el formulario del producto y la app de pedido (Releasit)
      $$('.product-information form input[name="id"], .product-information input[name="id"]').forEach(function (inp) {
        if (String(inp.value) !== String(v.id)) inp.value = v.id;
      });
      var url = new URL(window.location.href);
      if (url.searchParams.get('variant') !== String(v.id)) {
        url.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', url.toString());
      }
    }

    if (!info) return;
    var sel = selectedOptions();
    var current = sel[info.option] || (v ? v.options[(cfg.optionNames || []).indexOf(info.option)] : '');

    // Tarjetas
    $$('.lp-pack__card', info.el).forEach(function (card) {
      var on = card.getAttribute('data-value') === current;
      if (card.getAttribute('aria-checked') !== String(on)) card.setAttribute('aria-checked', String(on));
      card.tabIndex = on ? 0 : -1;
    });

    if (!vp) return;
    // Ocultar el grupo nativo del paquete (lo reemplazan las tarjetas)
    $$('fieldset', vp).forEach(function (fs) {
      var inp = $('input[data-option-name]', fs);
      if (!inp) return;
      var name = inp.getAttribute('data-option-name');
      if (name === info.option) setHidden(fs, 'lp-hide-fieldset', true);
      if (name === info.sizeOption) {
        var isSingle = info.single.indexOf(current) !== -1;
        setHidden(fs, 'lp-hide-fieldset', isSingle);
        // Con traje: esconder la opción "Única" (no aplica)
        $$('input', fs).forEach(function (i) {
          var lbl = i.closest('label');
          var singleValue = info.el.getAttribute('data-single-value');
          setHidden(lbl, 'lp-hide-value', !isSingle && i.value === singleValue);
        });
      }
    });
  }

  var syncTimer = null;
  function queueSync(delay) { clearTimeout(syncTimer); syncTimer = setTimeout(syncUI, delay || 40); }

  // Talla válida para el paquete elegido (evita combinaciones que no existen, ej. traje + "Única")
  function fixSize(info, vp, pack) {
    if (!info.sizeOption) return;
    var sizeInputs = $$('input[data-option-name="' + cssEscape(info.sizeOption) + '"]', vp);
    if (!sizeInputs.length) return;
    var singleValue = info.el.getAttribute('data-single-value');
    var names = cfg.optionNames || [];
    var pi = names.indexOf(info.option), si = names.indexOf(info.sizeOption);
    var valid = variants.filter(function (v) { return v.options[pi] === pack; }).map(function (v) { return v.options[si]; });
    var current = sizeInputs.filter(function (i) { return i.checked; })[0];
    if (current && valid.indexOf(current.value) !== -1) return;
    var target = sizeInputs.filter(function (i) { return valid.indexOf(i.value) !== -1 && (info.single.indexOf(pack) !== -1 || i.value !== singleValue); })[0];
    if (target) target.click();
  }

  function selectPackage(value) {
    var info = packInfo();
    var vp = picker();
    if (!info || !vp) return;
    var input = $('input[data-option-name="' + cssEscape(info.option) + '"][value="' + cssEscape(value) + '"]', vp);
    if (input && !input.checked) input.click();
    // Horizon normalmente elige una talla válida al actualizar; si no lo hizo, la corregimos
    setTimeout(function () { var p = picker(); if (p) fixSize(info, p, value); }, 900);
    // UI optimista mientras Horizon actualiza
    $$('.lp-pack__card', info.el).forEach(function (c) { c.setAttribute('aria-checked', String(c.getAttribute('data-value') === value)); });
    queueSync(60); setTimeout(syncUI, 450); setTimeout(syncUI, 1100);
  }

  function initPackages() {
    var info = packInfo();
    if (!info) return;
    info.el.addEventListener('click', function (e) {
      var card = e.target.closest('.lp-pack__card');
      if (card) selectPackage(card.getAttribute('data-value'));
    });
    info.el.addEventListener('keydown', function (e) {
      var keys = ['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft'];
      if (keys.indexOf(e.key) === -1) return;
      var cards = $$('.lp-pack__card', info.el);
      var idx = cards.indexOf(doc.activeElement);
      if (idx === -1) return;
      e.preventDefault();
      var next = cards[(idx + (e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1 : cards.length - 1)) % cards.length];
      next.focus();
      selectPackage(next.getAttribute('data-value'));
    });
    // "Elegir este paquete" desde las tarjetas de contenido
    doc.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-lp-choose]');
      if (!btn) return;
      e.preventDefault();
      selectPackage(btn.getAttribute('data-lp-choose'));
      info.el.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    });
  }

  function watchPicker() {
    doc.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('variant-picker')) { queueSync(60); setTimeout(syncUI, 600); } });
    var host = $('.product-information') || $('main');
    if (!host || !('MutationObserver' in window)) return;
    new MutationObserver(function () { queueSync(80); })
      .observe(host, { subtree: true, childList: true, attributes: true, attributeFilter: ['checked', 'data-current-checked', 'data-variant-id'] });
  }

  /* ---------- 3. Descripción con "Ver más" ---------- */
  function initDesc() {
    $$('[data-lp-desc]').forEach(function (box) {
      var body = $('.lp-desc__body', box);
      var btn = $('.lp-desc__toggle', box);
      if (!body || !btn) return;
      box.classList.add('is-clamped');
      if (body.scrollHeight <= body.clientHeight + 4) { box.classList.remove('is-clamped'); btn.hidden = true; return; }
      btn.hidden = false;
      btn.addEventListener('click', function () {
        var open = box.classList.toggle('is-clamped') === false;
        btn.setAttribute('aria-expanded', String(open));
        $('span', btn).textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
      });
    });
  }

  /* ---------- 4. Botón COD (Releasit): sellos + abrir el formulario ---------- */
  function badgeHTML() {
    return (cfg.badges || []).filter(Boolean).map(function (t) {
      return '<span class="lp-badge">' + ICON_CHECK + '<span>' + t + '</span></span>';
    }).join('');
  }
  function injectBadges() {
    if (!(cfg.badges || []).length) return;
    $$('.rsi-app-block-container').forEach(function (host) {
      if (host.querySelector(':scope > .lp-badges')) return;
      var w = doc.createElement('div');
      w.className = 'lp-badges';
      w.innerHTML = badgeHTML();
      host.appendChild(w);
    });
  }
  function codButton() {
    return $('.product-information .rsi-app-block-container #rsi_buy_now_button') || $('.rsi-app-block-container #rsi_buy_now_button') || $('#rsi_buy_now_button');
  }
  function openOrder() {
    var b = codButton();
    if (b) { b.click(); return; }
    var target = $('[data-lp-pack]') || $('.product-information');
    if (target) target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
  }
  function initOrderButtons() {
    doc.addEventListener('click', function (e) {
      var b = e.target.closest('[data-lp-order]');
      if (!b) return;
      e.preventDefault();
      openOrder();
    });
  }

  /* ---------- 5. Barra fija de compra ---------- */
  function initSticky() {
    if (!cfg.sticky) return;
    var bar = doc.createElement('div');
    bar.className = 'lp-sticky';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Pedido rápido');
    var v = currentVariant();
    var img = (v && v.img) || cfg.img;
    bar.innerHTML =
      (img ? '<img class="lp-sticky__img" src="' + img + '" alt="" width="50" height="50">' : '') +
      '<div class="lp-sticky__info"><div class="lp-sticky__title"></div><div class="lp-sticky__price"></div></div>' +
      '<button type="button" class="lp-sticky__btn"><span></span>' + ICON_ARROW + '</button>';
    $('.lp-sticky__title', bar).textContent = cfg.title || '';
    $('.lp-sticky__price', bar).textContent = v ? v.price : '';
    $('.lp-sticky__btn span', bar).textContent = cfg.stickyLabel || 'Pedir';
    $('.lp-sticky__btn', bar).addEventListener('click', openOrder);
    doc.body.appendChild(bar);

    var anchor = null, heroGone = false, finalVisible = false;
    function update() { bar.classList.toggle('is-visible', heroGone && !finalVisible); }
    function attach() {
      anchor = $('.product-information .rsi-app-block-container') || $('[data-lp-pack]') || $('.product-information');
      if (!anchor || !('IntersectionObserver' in window)) return false;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { heroGone = e.boundingClientRect.bottom < 0; update(); });
      }, { threshold: 0 }).observe(anchor);
      var fin = $('.lp-final__card');
      if (fin) new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { finalVisible = e.isIntersecting; update(); });
      }, { threshold: 0.35 }).observe(fin);
      return true;
    }
    if (!attach()) {
      var n = 0, iv = setInterval(function () { if (attach() || ++n > 20) clearInterval(iv); }, 400);
    }
  }

  /* ---------- 6. Cuenta regresiva ---------- */
  function initCountdown() {
    $$('[data-lp-countdown]').forEach(function (box) {
      var end = Date.parse(box.getAttribute('data-deadline'));
      var wrap = box.closest('.lp-final__card') || box.parentNode;
      var after = $('[data-lp-after]', wrap);
      if (isNaN(end)) { box.hidden = true; return; }
      var cells = { d: $('[data-u="d"]', box), h: $('[data-u="h"]', box), m: $('[data-u="m"]', box), s: $('[data-u="s"]', box) };
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var diff = end - Date.now();
        if (diff <= 0) {
          box.hidden = true;
          $$('[data-lp-before]', wrap).forEach(function (el) { el.hidden = true; });
          if (after) after.hidden = false;
          clearInterval(t);
          return;
        }
        var s = Math.floor(diff / 1000);
        cells.d.textContent = pad(Math.floor(s / 86400));
        cells.h.textContent = pad(Math.floor((s % 86400) / 3600));
        cells.m.textContent = pad(Math.floor((s % 3600) / 60));
        cells.s.textContent = pad(s % 60);
      }
      var t = setInterval(tick, 1000);
      tick();
    });
  }

  /* ---------- 7. Carrusel con puntos ---------- */
  function initCarousels() {
    $$('[data-lp-carousel]').forEach(function (track) {
      var dots = track.parentNode.querySelector('.lp-dots');
      var cards = $$(':scope > *', track);
      if (!dots || cards.length < 2) return;
      dots.innerHTML = cards.map(function () { return '<span></span>'; }).join('');
      var ds = $$('span', dots);
      function update() {
        var center = track.scrollLeft + track.clientWidth / 2, best = 0, bestD = Infinity;
        cards.forEach(function (c, i) { var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - center); if (d < bestD) { bestD = d; best = i; } });
        ds.forEach(function (d, i) { d.classList.toggle('is-active', i === best); });
      }
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      update();
    });
  }

  /* ---------- 8. FAQ: una respuesta abierta a la vez (respaldo si no hay details[name]) ---------- */
  function initFaq() {
    var supportsName = 'name' in doc.createElement('details');
    if (supportsName) return;
    $$('.lp-faq').forEach(function (faq) {
      faq.addEventListener('toggle', function (e) {
        if (!e.target.open) return;
        $$('details', faq).forEach(function (d) { if (d !== e.target) d.open = false; });
      }, true);
    });
  }

  /* ---------- 9. Videos: reproducir solo cuando se ven ---------- */
  function setToggle(btn, paused) {
    if (!btn) return;
    btn.classList.toggle('is-paused', paused);
    btn.setAttribute('aria-label', paused ? 'Reproducir video' : 'Pausar video');
  }
  function initVideos() {
    var vids = $$('.lp-media video');
    vids.forEach(function (v) {
      v.muted = true;
      v.setAttribute('playsinline', '');
      var btn = v.parentNode.querySelector('[data-lp-video-toggle]');
      if (reduceMotion) { v.pause(); setToggle(btn, true); }
      if (btn && !btn.dataset.bound) {
        btn.dataset.bound = '1';
        btn.addEventListener('click', function () {
          if (v.paused) { v.dataset.userPaused = ''; var p = v.play(); if (p && p.catch) p.catch(function () {}); setToggle(btn, false); }
          else { v.dataset.userPaused = '1'; v.pause(); setToggle(btn, true); }
        });
      }
    });
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting && !reduceMotion && v.dataset.userPaused !== '1') { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else if (!e.isIntersecting) v.pause();
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { io.observe(v); });
  }

  /* ---------- 11. Releasit: paquetes con el diseño de ofertas de Releasit ----------
     Releasit solo multiplica unidades, no vende paquetes distintos. El formulario muestra
     una tarjeta por paquete con el estilo de sus ofertas (precio tachado + etiqueta), con
     imagen y precio fijos, y la talla solo en los paquetes con traje. Por dentro se usa la
     oferta "1 unidad" de Releasit (oculta) y su selector de variante nativo.
     Precio tachado y etiqueta: bloque "LP · Tarjetas de paquete" (Formulario Releasit). */
  var selectSetter = Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, 'value').set;
  var GID = 'gid://shopify/ProductVariant/';

  function rsiOffers() { return $$('.rsi-quantity-product'); }
  function rsiSelect() {
    var offers = rsiOffers();
    if (!offers.length) return null;
    var first = offers[0];
    var sel = first.querySelector('.rsi-variant-picker-wrapper select');
    if (!sel) {
      // La oferta de 1 unidad aún no está elegida: la elegimos (máx. una vez por segundo)
      var last = +(first.getAttribute('data-lp-clicked') || 0);
      if (Date.now() - last > 1000) { first.setAttribute('data-lp-clicked', Date.now()); first.click(); }
      return null;
    }
    return sel;
  }
  function rsiSetVariant(sel, id) {
    var value = GID + id;
    if (sel.value === value) return;
    selectSetter.call(sel, value);
    sel.dispatchEvent(new Event('input', { bubbles: true }));
    sel.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function rsiIdx() {
    var info = packInfo();
    var names = cfg.optionNames || [];
    return info ? { info: info, pi: names.indexOf(info.option), si: names.indexOf(info.sizeOption) } : null;
  }
  function rsiChoose(pack, size) {
    var sel = rsiSelect(), ix = rsiIdx();
    if (!sel || !ix) return;
    var cur = variants.filter(function (v) { return GID + v.id === sel.value; })[0] || variants[0];
    pack = pack || cur.options[ix.pi];
    size = size || cur.options[ix.si];
    var cands = variants.filter(function (v) { return v.options[ix.pi] === pack; });
    var v = cands.filter(function (x) { return x.options[ix.si] === size; })[0] || cands[0];
    if (v) rsiSetVariant(sel, v.id);
  }
  function rsiEsc(t) {
    return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function rsiNum(t) { return +String(t || '').replace(/[^\d]/g, '') || 0; }
  function rsiMoney(n) { return '$' + Math.round(n).toLocaleString('es-CO') + ',00'; }
  function rsiBuildBox() {
    var ix = rsiIdx();
    var src = $$('[data-lp-pack] .lp-pack__card');
    if (!ix || !src.length) return null;
    var box = doc.createElement('div');
    box.className = 'lp-rq-list';
    box.setAttribute('role', 'radiogroup');
    box.setAttribute('aria-label', 'Elige tu paquete');
    box.innerHTML = src.map(function (c) {
      var val = c.getAttribute('data-value');
      var img = c.querySelector('img');
      var name = ($('.lp-pack__name', c) || {}).textContent || val;
      var sub = ($('.lp-pack__sub', c) || {}).textContent || '';
      var v = variants.filter(function (x) { return x.options[ix.pi] === val; })[0];
      var price = v ? rsiNum(v.price) : 0;
      var was = rsiNum(c.getAttribute('data-rsi-was'));
      var tag = (c.getAttribute('data-rsi-tag') || '').trim();
      var hasWas = was > price;
      return '<div class="lp-rq" role="radio" aria-checked="false" tabindex="0" data-value="' + rsiEsc(val) + '">' +
        '<div class="lp-rq__row">' +
          (img ? '<img class="lp-rq__img" src="' + rsiEsc(img.getAttribute('src')) + '" alt="" width="64" height="64">' : '') +
          '<div class="lp-rq__body">' +
            '<div class="lp-rq__top"><span class="lp-rq__title">' + rsiEsc(name) + '</span><span class="lp-rq__radio" aria-hidden="true"></span></div>' +
            (sub ? '<div class="lp-rq__sub">' + rsiEsc(sub) + '</div>' : '') +
            '<div class="lp-rq__bottom">' +
              '<span class="lp-rq__prices"><span class="lp-rq__price">' + (price ? rsiMoney(price) : '') + '</span>' +
                (hasWas ? '<s class="lp-rq__was">' + rsiMoney(was) + '</s>' : '') + '</span>' +
              (tag ? '<span class="lp-rq__tag' + (hasWas ? ' lp-rq__tag--deal' : '') + '">' + rsiEsc(tag) + '</span>' : '') +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');
    box.addEventListener('click', function (e) {
      if (e.target.closest('.lp-rq__size')) return; // el selector de talla maneja lo suyo
      var card = e.target.closest('.lp-rq');
      if (!card) return;
      e.preventDefault();
      e.stopPropagation();
      rsiChoose(card.getAttribute('data-value'), null);
      setTimeout(rsiTick, 60);
    });
    box.addEventListener('keydown', function (e) {
      var card = e.target.closest('.lp-rq');
      if (!card || e.target !== card || (e.key !== 'Enter' && e.key !== ' ')) return;
      e.preventDefault();
      rsiChoose(card.getAttribute('data-value'), null);
      setTimeout(rsiTick, 60);
    });
    box.addEventListener('change', function (e) {
      if (!e.target.classList.contains('lp-rq__select')) return;
      e.stopPropagation();
      rsiChoose(null, e.target.value);
      setTimeout(rsiTick, 60);
    });
    return box;
  }
  function rsiRender(sel, box) {
    var ix = rsiIdx();
    if (!ix) return;
    var cur = variants.filter(function (v) { return GID + v.id === sel.value; })[0];
    if (!cur) return;
    var pack = cur.options[ix.pi], size = cur.options[ix.si];
    $$('.lp-rq', box).forEach(function (c) {
      var val = c.getAttribute('data-value');
      var on = val === pack;
      if (c.getAttribute('aria-checked') !== String(on)) c.setAttribute('aria-checked', String(on));
      var wrap = $('.lp-rq__size', c);
      var withSize = on && ix.info.single.indexOf(val) === -1;
      if (!withSize) { if (wrap) wrap.remove(); return; }
      var sizes = variants.filter(function (v) { return v.options[ix.pi] === val; }).map(function (v) { return v.options[ix.si]; });
      var key = sizes.join(',');
      if (!wrap || wrap.getAttribute('data-key') !== key) {
        if (wrap) wrap.remove();
        wrap = doc.createElement('label');
        wrap.className = 'lp-rq__size';
        wrap.setAttribute('data-key', key);
        wrap.innerHTML = '<span class="lp-rq__size-label">Talla</span><select class="lp-rq__select">' +
          sizes.map(function (s) { return '<option value="' + rsiEsc(s) + '">' + rsiEsc(s) + '</option>'; }).join('') + '</select>';
        c.appendChild(wrap);
      }
      var s = $('.lp-rq__select', wrap);
      if (s.value !== size && doc.activeElement !== s) s.value = size;
    });
  }
  function rsiTick() {
    var offers = rsiOffers();
    if (!offers.length) return;
    var sel = rsiSelect();
    var box = $('.lp-rq-list');
    if (!box) {
      box = rsiBuildBox();
      if (!box) return;
      var anchor = offers[0].parentNode;
      anchor.parentNode.insertBefore(box, anchor);
    }
    if (sel) rsiRender(sel, box);
  }
  function initRsiPackages() {
    setInterval(rsiTick, 300);
  }

  /* ---------- 10. Cinta: tocar o Enter para pausar ---------- */
  function initTicker() {
    $$('[data-lp-ticker]').forEach(function (t) {
      if (t.dataset.bound) return;
      t.dataset.bound = '1';
      function toggle() { t.classList.toggle('is-paused'); }
      t.addEventListener('click', toggle);
      t.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
    });
  }

  onReady(function () {
    initReveal();
    initPackages();
    watchPicker();
    syncUI();
    initDesc();
    initOrderButtons();
    initSticky();
    initCountdown();
    initCarousels();
    initFaq();
    initVideos();
    initTicker();
    initRsiPackages();
    // Releasit carga su botón de forma asíncrona
    injectBadges();
    var n = 0, iv = setInterval(function () { injectBadges(); syncUI(); if (++n > 16) clearInterval(iv); }, 500);
  });

  // Editor de temas: re-inicializar al editar secciones
  doc.addEventListener('shopify:section:load', function () {
    initReveal(); initDesc(); initCountdown(); initCarousels(); initVideos(); initTicker(); injectBadges(); syncUI();
  });
})();
